<template lang="html">
  <transition name="fade">
  <div v-if="active" class="loading d-flex justify-content-center">
    <div :class="spinnerClass" class="spinner-border text-center text-success" role="status"></div>
  </div>
  </transition>
</template>

<script>
export default {
  props: {
    active: Boolean,
    small: Boolean,
    top: Boolean
  },

  computed: {
    spinnerClass () {
      let dinamicClass = this.small ? 'loading-small ' : 'loading-big '
      dinamicClass += this.top ? 'loading-top' : ''
      return dinamicClass
    },
  },
}
</script>

<style lang="scss" scoped>

  .loading {
    position: absolute;
    left: 0;
    top: 0;
    background-color: #fff;
    opacity: 0.9;
    width: 100%;
    height: 100vh;
    z-index: 1000;

    & .loading-big {
      margin: auto;
      height: 4rem !important;
      width: 4rem !important;
    }

    & .loading-small {
      margin: auto;
      height: 1.5rem !important;
      width: 1.5rem !important;
    }

    & .loading-top {
      margin-top: 4rem !important;
    }
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/Loading.vue